import type { AuthUser } from './auth-provider'

const CACHE_KEY = 'user'

export function getCachedUserIdentity(): AuthUser | null {
  try {
    const stored = localStorage.getItem(CACHE_KEY)
    if (!stored) return null
    return JSON.parse(stored) as AuthUser
  } catch {
    return null
  }
}

export function setCachedUserIdentity(user: AuthUser): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(user))
  } catch {
    // localStorage unavailable or full
  }
}

export function clearCachedUserIdentity(): void {
  localStorage.removeItem(CACHE_KEY)
}
